<template>    
        <v-container fluid pa-0>
         <v-list v-if="(editedItems != []) && (editedItems[0].descuentos) && (editedItems[0].descuentos.length > 0)"
         dense fluid>                 
                 <v-layout row wrap>
                    <v-flex xs6>
                        <v-subheader class="nopadding compact blue--text">Descuentos</v-subheader> 
                    </v-flex>
                   
                    <v-flex xs6>
                        <v-subheader class="nopadding compact blue--text">Cant Min</v-subheader> 
                    </v-flex>                   
                    </v-layout>                    
                <v-list-tile
                v-for="(dto, i) in editedItems[0].descuentos"
                :key="i"                
                >       
                <v-layout row wrap >
                    <v-flex xs6>
                        {{dto.discount}} %
                    </v-flex>
                    <v-flex xs6>
                        {{dto.minQtyDesc}}
                    </v-flex>                    
                    </v-layout>             
                </v-list-tile>
        </v-list>
        </v-container>

</template>
<script>
export default {
    name: 'descuentosArticulo',    
    data(){
        return{

        }
    },
    computed:{
        editedItems:{
            get(){
                return this.$store.state.editedItems;
            },
            set(value){
                this.$store.state.editedItems = value;
            }
        }
    }
}
</script>
<style scoped>
.nopadding{
    padding: 0px;
}
.compact{
    height: 20px;
}
</style>